import type { Follow } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { defaultFollow } from "./defaultFollow"
import { useAccount } from "src/hooks/account"


export function useDefaultFollow(): Follow {
  const { data: account } = useAccount()
  const accountId = account?.id

  return useMemo(
    () => ({
      ...defaultFollow,
      account_id: accountId ?? defaultFollow.account_id,
    }),
    [accountId],
  )
}
